var React = require('react');

function Brush (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 32v224H0V32A32 32 0 0 1 32 0h320a32 32 0 0 1 32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 288v32a64 64 0 0 0 64 64h64v64a64 64 0 0 0 128 0v-64h64a64 64 0 0 0 64-64v-32zm192 184a24 24 0 1 1 24-24 24 24 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

Brush.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Brush;

Brush.default = Brush;
